import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=93b88c76&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=93b88c76&prod&scoped=true&lang=scss&"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=93b88c76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b88c76",
  null
  
)

export default component.exports